module.exports = __webpack_public_path__ + "static/media/Roboto-Light.46ab9fb4.otf";